<template>
    <div ref="questionBox" class="page-answer">
        <div :style="blankStyle1"></div>
        <div id="cardmain" class="cardmain" v-show="cardshow">
            <div class="card-list">
                <div class="card-wrapper" :style="wrapperStyle()">
                    <div class="card-box" v-for="(item, index) in cumQuestions">
                        <div :class="cardClass(index)" :refresh="refresh">
                            <div class="question-wrap" @scroll.stop>
                                <div class="question" v-html="`${index+1}、${item.title}`"></div>
                                <div class="img-wrapper" v-if="item.cover">
                                    <img :src="item.cover">
                                </div>
                                <div class="options">
                                    <div @click="selectOption(item, option)" 
                                        v-for="(option, optionIndex) in item.choices" 
                                        class="option">
                                        <div class="option-label">{{optionLabel[optionIndex]}}</div>
                                        <div class="option-content">{{option.title}}</div>
                                        <div class="option-radio">
                                            <div :style="radioStyle(item, option)" :class="['radio', item.answer==option?'selected':'']">
                                                <span :style="radioSpanStyle(item, option)"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="action-wrap">
                                <div :style="prebtnStyle" @click="preBtnClick(item)" v-show="showPrev(index)" class="action-btn">
                                    上一题
                                </div>
                                <div :style="smbtnStyle" @click="submit" 
                                    v-show="showSubmit(index)" 
                                    :class="{'action-btn':true, 'action-submit':true, 'action-nosubmit':!cansubmit}">
                                    提交
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-mark">
                <div class="curIndex">{{curIndex+1}}</div>
                <div ref="curline" class="line"></div>
                <div class="totalIndex">{{cumQuestions.length}}</div>
            </div>
        </div>

        
    </div>
</template>

<script>
import utils from '@/js/utils'
import SceneCodePop from "@/components/SceneCodePop.vue"

export default {
  name: 'page-answer',
  components: {
      SceneCodePop,
  },

  // 页面title
  title: '壹心理测试 | 答题页',

  data() {
    return {
        curIndex: 0,
        sceneShow: true,
        sceneCode: "",
        cansubmit: false,
        mypagemeta: null,
        blankStyle1: '',
        refresh: 0,
        cardshow: false,
        cumQuestions: null,
        locked: false,
    }
  },
  created() {
      let cumQuestions = this.questions;
      if (this.ceshi.customflag == 11) {
          cumQuestions = utils.randomArr(this.questions, 10);
      }
      this.cumQuestions = cumQuestions;

      let pagemeta = this.pagemeta.questionPage;
      this.mypagemeta = pagemeta;
      console.log('questionPage', pagemeta);
  },
  mounted() {
      this.$refs.questionBox.style.height = window.innerHeight + 'px';
      let pagemeta = this.mypagemeta;
    if (this.isX && pagemeta.bgurlx) {
        pagemeta.bgurl = pagemeta.bgurlx;
        pagemeta.bgheight = pagemeta.bgheightx;
    }
    if (pagemeta.bgurl) {
        this.$refs.questionBox.style.backgroundImage = `url('${pagemeta.bgurl}')`;
        window.questionBox = this.$refs.questionBox;
        console.log('bgurl', pagemeta.bgurl)
    }
    if (pagemeta.bgheight) {
        // this.$refs.questionBox.style.backgroundSize = `100% ${utils.rem2px(pagemeta.bgheight)}px`;
        this.$refs.questionBox.style.backgroundSize = 'cover';
    }
    if (pagemeta.bgcolor) {
        this.$refs.questionBox.style.backgroundColor = pagemeta.bgcolor;
    }
    if (pagemeta.fontcolor) {
        this.$refs.questionBox.style.color = pagemeta.fontcolor;
        this.$refs.curline.style.backgroundColor = pagemeta.fontcolor;
    }
    this.cardshow = true;
    this.$nextTick(() => {
        this.blankStyle1 = this.getBlankStyle1();
    })
  },
  computed: {
    optionLabel() {
        var list = [];
        for (var i = 0; i < 20; i++) {
        list.push(String.fromCharCode(65 + i));
        }
        return list;
    },
    prebtnStyle() {
        if (!this.mypagemeta.btncolor) {
            return '';
        }
        let color1 = this.mypagemeta.btncolor;
        let style = `background-color:${color1};`;
        let color2 = this.mypagemeta.btnfontcolor;
        style += `color:${color2};`;
        return style;
    },
    smbtnStyle() {
        if (this.cansubmit) {
            return this.prebtnStyle;
        }
        return '';
    },
  },
  methods: {
      wrapperStyle() {
        let cardBox = $('.card-box')[0];
        console.log($('.card-box'), cardBox)
        if (!cardBox) {
            return;
        }
        let card = $('.card')[0];
        let cardWidth = card.offsetWidth;
        let cardBoxWidth = $('.card-box')[0].offsetWidth;
        let appWidth = $('#app').width();
        let gap = (appWidth - cardWidth) / 2;
        let pm = gap - cardBoxWidth * this.curIndex;
        // let pm =  utils.rem2px(53 - 674 * this.curIndex);
        return {
            'transition-duration': '300ms',
            'transform': `translate3d(${pm}px, 0, 0)`
        }
    },
      getBlankStyle1() {
        let div1 = document.getElementById('cardmain');
        let winHeight = window.innerHeight;
        let div1Height = div1.offsetHeight;
        let top = (winHeight - div1Height) / window.pxbase;
        console.log(winHeight, div1Height, top);
        return `height:${top}px;`;
    },
    radioStyle(item, option) {
        if (!this.mypagemeta.btncolor) {
            return '';
        }
        let color = this.mypagemeta.btncolor;
        let style = `border-color:${color};`
        // if (item.answer == option.value) {
        //     style += `background-color:${color};`;
        // }
        return style;
    },
    radioSpanStyle(item, option) {
        if (!this.mypagemeta.btncolor) {
            return '';
        }
        let color = this.mypagemeta.btncolor;
        let style = ''
        if (item.answer == option) {
            style += `background-color:${color};`;
        }
        return style;
    },
    cardClass(index) {
        return {
            'card': true,
            'card-active': this.curIndex == index,
        }
    },
    showPrev(index) {
        return index > 0;
    },
    showSubmit(index) {
        return index == (this.cumQuestions.length - 1);
    },
    preBtnClick(item) {
        let index = this.curIndex - 1;
        if (index < 0) {
            return;
        }
        this.$set(item, "answer", undefined);
        this.setCurIndex(index);
        this.cansubmit = false;
    },
    setCurIndex(index) {
        if (index < 0 || index >= this.cumQuestions.length) {
            this.locked = false;
            return;
        }
        new Promise(resolve => {
            setTimeout(() => {
                this.curIndex = index;
                resolve();
            }, 200)
        }).then(() => {
            setTimeout(() => {
                this.locked = false;
                console.log('locked false');
            }, 300);
        });
    },
    selectOption(item, choice) {
        if (this.locked) {
            return;
        }
        this.locked = true;

        this.$set(item, "answer", choice);
        let index = this.curIndex + 1;
        this.setCurIndex(index);
        this.refresh++;
        console.log('option:', index, choice)

        if (index >= this.cumQuestions.length) {
            this.cansubmit = true;
        }
    },
    sceneShowChange(val) {
        this.sceneShow = val;
    },
    submit() {
        if (this.cansubmit == false) {
            return;
        }
        if (window.submitLocked) {
            return;
        }

        this.$toasted.show('正在生成结果...');

        let score = 0;
        for (const item of this.cumQuestions) {
            console.log(item.answer);
            let val = parseInt(item.answer.value);
            score += val;
        }

        let result = null;
        for (let i=0; i<this.results.length; i++) {
            result = this.results[i];
            if (result.score == score) {
                break;
            } else {
                let score1 = parseInt(result.score1);
                let score2 = parseInt(result.score2);
                if (score >= score1 && score <= score2) {
                    break;
                }
            }
        }
        let cover = result.cover;

        window.submitLocked = true;
        let url = this.$apis.result;
        let keyid = `ceshi:cmapp:${window.ceshiId}`;
        let userid = localStorage.getItem(keyid) || 0;
        
        this.$axios.post(url, this.$qs.stringify({
            unionid: window.unionid,
            userid,
            wxmp: window.wxmp,
            id: window.ceshiId,
            cover,
            score,
            result: JSON.stringify(result)
            })
        ).then(res => {
            if (res.data.errcode == 0) {
                let Data = res.data.data;
                window.resultData = Data;
                Data.userResult.hadsub = Data.hadsub;
                Data.userResult.sceneCode = Data.suburl;

                let suburl = Data.suburl;
                let scanurl = Data.scanurl;
                let userid = Data.userResult.userid;
                let stinfo = Data.stinfo;
                let placard = Data.userResult.placard;

                if (Data.hadsub) {
                    this.setUserResult(Data.userResult);
                    this.$router.replace({
                        name: 'result',
                    })
                } else {
                    if (ceshiId == 68) {
                        stinfo = 3;
                    }
                    let tourl = `${scanurl}#/?id=${window.ceshiId}&userid=${userid}&stinfo=${stinfo}&suburl=${escape(suburl)}&placard=${escape(placard)}`;
                    location.href = tourl;
                }
                
                // if (Data.hadsub) {
                //     this.setUserResult(Data.userResult);
                //     this.$router.replace({
                //         name: 'result',
                //     })
                // } else {
                //     this.sceneShow = true;
                //     this.sceneCode = Data.suburl;
                // }
            }
        }).finally(() => {
            window.submitLocked = false
            this.$toasted.clear();
        })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.page-answer {
    height: 100%;
}
.card-list {
    overflow: hidden;
    // padding-top: px2rem(30);
}
.card-wrapper {
    display: -webkit-box;
}
.card-box {
    width: px2rem(644);
    padding-bottom: px2rem(30);
    padding-right: px2rem(30);
}
.card {
    height: px2rem(940);
    box-shadow: 0 px2rem(11) px2rem(16) 0 rgba(0, 0, 0, 0.21);
    border-radius: px2rem(12);
    background: #FFFFFF;
    padding: px2rem(40) px2rem(72) px2rem(0) px2rem(72);
    // color: #333;
    overflow-y: scroll;
    transition: 300ms;
}
.card:not(.card-active) {
    transform: scale3d(1, .9, 1)
}
.img-wrapper {
    width: 100%;
    margin-bottom: px2rem(30);
    // border: 1px solid #eaeaea;
    img {
        max-width: 100%;
        max-height: 100%;
    }
}
.question-wrap {
    min-height: px2rem(760);
}
.question {
    line-height: px2rem(56);
    margin-bottom: px2rem(40);
    font-size: px2rem(36);
    font-weight: bold;
    line-height: px2rem(56);
}
.img-wrapper {
    width: 100%;
    margin-bottom: px2rem(30);
    border: 1px solid #eaeaea;
    img {
        max-width: 100%;
        max-height: 100%;
    }
}
.options {
    .option {
        &:last-child {
            border-bottom: none;
        }
        font-size: px2rem(32);
        padding: px2rem(20) 0;
        line-height: px2rem(56);
        border-bottom: 1px solid #eaeaea;
        display: flex;
        &-label {
            margin-right: px2rem(23);
        }
        &-content {
            flex: 1;
        }
        &-radio {
            margin-left: px2rem(23);
            align-items: center;
            display: flex;
            .radio {
                width: px2rem(20);
                height: px2rem(20);
                border: px2rem(4) solid #ffdd2b;
                border-radius: 50%;
                padding: px2rem(4);
                line-height: px2rem(20);
                font-size: unset;
                span {
                    border-radius: 50%;
                    display: inline-block;
                    width: px2rem(20);
                    height: px2rem(20);
                }
                &.selected {
                    span {
                        background-color: #ffdd2b;
                    }
                }
            }
        }
    }
}
.page-mark {
    position: relative;
    text-align: center;
    margin-top: px2rem(20);
    .line {
        display: inline-block;
        width: 1px;
        height: px2rem(70);
        background-color: #666;
        transform: rotate(30deg);
    }
    .curIndex {
        position: absolute;
        top: px2rem(-10);
        left: 50%;
        // color: #333;
        transform: translate(-110%, 0%);
        font-size: px2rem(38);
    }

    .totalIndex {
        position: absolute;
        // color: #666;
        bottom: 0;
        right: 50%;
        transform: translate(110%, 0);
        font-size: px2rem(32);
    }
}
.action-wrap {
    line-height: px2rem(88);
    display: flex;
    // position: absolute;
    // left: px2rem(72);
    // right: px2rem(72);
    // bottom: px2rem(60);
    height: px2rem(88);
    .action-btn {
        text-align: center;
        border-radius: px2rem(10);
        box-sizing: border-box;
        padding: 0 px2rem(22);
        text-align: center;
        display: inline-block;
        background-color: #FFDD2B;
        flex: 1;
        color: #D35E00;
    }
    .action-submit {
        margin-left: px2rem(20);
    }
    .action-nosubmit {
        background-color: #dddddd;
        color: #999;
    }
}
</style>

